import React from 'react';
import Text, { TextSize, TextProps } from '../../../Text';
import { st, classes } from './Label.st.css';

type LabelSize = Extract<TextSize, 'small' | 'tiny'>;

interface Props extends Pick<TextProps, 'aria-hidden' | 'ellipsis' | 'id'> {
  dataHook: string;
  label: React.ReactNode;
  tagName?: 'label';
  labelSize?: LabelSize;
  hasInlineElements?: boolean;
}

const Label = ({
  labelSize,
  label,
  'aria-hidden': ariaHidden,
  hasInlineElements,
  ...rest
}: Props) => {
  const weight = labelSize === 'tiny' ? 'normal' : undefined;

  return (
    <Text
      aria-hidden={ariaHidden}
      className={st(classes.root, {
        hasInlineElements,
        labelSize,
      })}
      size={labelSize}
      weight={weight}
      secondary
      style={{ display: 'block' }} // allows the label to middle vertically
      {...rest}
    >
      {label}
    </Text>
  );
};

export default Label;
